/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IDefaActionTileViewProps } from './defa-action-tile';

export default (props: IDefaActionTileViewProps) => {
    const {
        baseClassName,
        backgroundImage,
        heading,
        actionLink
    } = props;

    return (
        <div className={baseClassName}>
            <div className={`${baseClassName}__background-image-wrapper`}>
                {backgroundImage}
            </div>
            <div className={`${baseClassName}__overlay`}>
                {heading}
                {actionLink}
            </div>
        </div>
    );
};
